import styled from '@emotion/styled';
import React from 'react';

interface IStyledBackground extends ThemeProps {
    width: string;
    imgUrl: string;
    height: string;
}

const Div = React.forwardRef(
    ({ width, imgUrl, height, ...rest }: IStyledBackground, ref: React.Ref<HTMLDivElement>) => {
        return <div ref={ref} {...rest} />;
    },
);
Div.displayName = 'Div';

export const StyledContentWrapper = styled.div`
    position: relative;
    height: 100%;
`;
export const StyledImageContainer = styled.div<IStyledBackground>`
    position: relative;
    height: ${(props) => props.height};

    > span {
        height: 100% !important;
    }
`;

export const AbsoluteWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
`;
